
import { AnimatePresence, motion } from 'motion/react';
import React, { Fragment, MouseEventHandler, useCallback } from 'react';
import useDebounce from '../../../utils/hooks/useDebounce';
import useArray from '../../../utils/hooks/useArray';

interface ComingSoonPopupProps {
    returnCb?: Function,
    context?: any,
    left: number,
    top: number
}

const ComingSoonPopup: React.FC<ComingSoonPopupProps> = ({ returnCb, left, top }) => {
    useDebounce(() => {
        if (returnCb) {
            returnCb();
        }
    }, 3000, [])

    return (
        <motion.div
            layout
            initial={{ y: 25, opacity: 0, transition: { duration: 1, ease: 'easeOut' } }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -25, opacity: 0, transition: { duration: .1, ease: 'easeIn' } }}
            className='size-full min-w-max min-h-max flex justify-center items-center px-4 py-2 bg-red-800 z-50 select-none pointer-events-none absolute'
            style={{ 
                filter: 'drop-shadow(0px 4px 12px rgba(0, 0, 0, .5))',
            }}
        >
            <h2 className='text-white text-teko text-2xl min-w-max'>Coming soon!</h2>
        </motion.div>
    )
}

const ComingSoonWrap: React.FC<any> = ({ children }) => {
    const { array, push, update } = useArray<any>([])

    const handleOnClick: MouseEventHandler = useCallback((e) => {
        let newIndex = array.length;
        let onComplete = () => { 
            update(newIndex, (<Fragment key={newIndex} />));
        };
        push(<ComingSoonPopup left={e.clientX} top={e.clientY} key={`${Math.random()}`} returnCb={onComplete} />)
    }, [array])

    return (
        <div
            className='flex justify-center items-center relative'
            onClick={handleOnClick}
        >
            {children}
            <AnimatePresence>
                {array.map((v) => v)}
            </AnimatePresence>
        </div>
    )
}

export default ComingSoonWrap;